import { useEffect } from 'react';
import jsonData from './data.json';
// import HyperLink from "../../components/HyperLink/HyperLink";
import './style.css';
import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CounterSection from '../../sections/CounterSection/CounterSection';
import CustomerSection from '../../sections/CustomersSection/CustomerSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import BlogSection from '../../sections/BlogSection/BlogSection';
import CaseStudySection from '../../sections/CaseStudySection/CaseStudySection';
import { GlobalStyle } from '../../global/global';
import CarouselSectionWithImages from '../../sections/CarouselSecitionWithImages/CarouselSectionWithImages';

import { Text,  } from '@chakra-ui/react';
import PromoBar from '../../sections/PromoBar/PromoBar';

interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=291932&ext=.jpg',
    alt: 'Zdjęcie wyróżniające w hero - strona główna',
};

export default function HomePage(props: Props) {
    const [offerSectionData] = jsonData.blocks;

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Najbardziej efektywna sprzedażowo platforma dla sklepów internetowych "
                image={image}
                buttons={[
                    {
                        title: 'Wypróbuj demo sklepu',
                        href: 'https://www.idosell.com/pl/demo/try-idosell-demo-for-free/',
                        variant: 'default',
                    }, 
                    {
                        title: 'Zamów sklep',
                        href: 'https://www.idosell.com/pl/abonamenty/',
                        variant: 'outline',
                    },
                ]}
            />
            <div className="homepage containerIdosellPages">
                <PromoBar
                    eyebrow="WIĘKSZA sprzedaż, LEPSZA platforma"
                    title={<Text>Teraz 5 000 zł taniej!</Text>}
                    version="green"
                    dueTo="Oferta obowiązuje do 30.04.2025"
                    buttonText="Dowiedz się więcej"
                    href="https://eu1.hubs.ly/H0hZKj00"
                />
                <CounterSection
                    title="Uruchom sklep internetowy"
                    subtitle="Z nami klienci rosną i sprzedają więcej"
                    layout="1x4"
                    items={[
                        {
                            mainNumber: '16,5',
                            additionalText: ' mld zł',
                            text: 'sumaryczna wartość transakcji rocznie (GMV)',
                        },
                        {
                            mainNumber: '~8',
                            additionalText: ' tys.',
                            text: 'aktywnych sklepów internetowych',
                        },
                        {
                            mainNumber: '60',
                            additionalText: ' mln',
                            text: 'transakcji rocznie',
                        },
                        {
                            mainNumber: '25',
                            additionalText: ' lat',
                            text: 'doświadczenia w branży e-commerce',
                        },
                    ]}
                    data="string"
                />
                <TilesSection
                    title={offerSectionData.title}
                    tiles={[
                        {
                            title: 'Gotowe integracje',
                            content:
                                'Z IdoSell nie musisz szukać integracji na własną rękę, ani martwić się o ich aktualizację i poprawność działania. Korzystając z naszego rozwiązania, zintegrujesz się m.in. z systemami płatności, kurierami, porównywarkami cen czy serwisami z opiniami.',
                            link: {
                                label: 'Przejdź',
                                href: 'https://www.idosell.com/pl/integracje/',
                                target: '_blank',
                            },
                        },
                        {
                            title: 'Wbudowany WMS',
                            content:
                                'Posiadamy wbudowany system do obsługi wielu magazynów, zarówno własnych, jak i dostawców. Za pomocą intuicyjnych narzędzi obsłużysz zwroty, reklamacje i wystawisz niezbędne dokumenty sprzedaży.',
                            link: {
                                label: 'Przejdź',
                                href: 'https://www.idosell.com/pl/system-zarzadzania-magazynem/',
                                target: '_blank',
                            },
                        },
                        {
                            title: 'Sprzedaż międzynarodowa',
                            content:
                                'Rynek europejski jest w zasięgu ręki. Z IdoSell zyskujesz dostęp do wbudowanych integracji z globalnymi partnerami.',
                            link: {
                                label: 'Przejdź',
                                href: 'https://www.idosell.com/pl/sprzedaz-miedzynarodowa/',
                                target: '_blank',
                            },
                        },
                        {
                            title: 'Sklep gotowy do sprzedaży',
                            content:
                                'Nasi eksperci spersonalizują sklep pod twoje potrzeby. Uruchomią te integracje i funkcjonalności, które są najbardziej przydatne i pomogą ci w szybkim starcie sprzedaży na IdoSell. Z nami otrzymasz sklep gotowy do sprzedaży.',
                            link: {
                                label: 'Przejdź',
                                href: 'https://www.idosell.com/pl/order/',
                                target: '_blank',
                            },
                        },
                        {
                            title: 'Fulfillment',
                            content:
                                'W IdoSell znajdziesz integracje z najlepszymi partnerami logistycznymi, którzy zrealizują twoje zamówienia, obsłużą zwroty, wynegocjują umowy z kurierami i będą odpowiadać za pakowanie towarów.',
                            link: {
                                label: 'Przejdź',
                                href: 'https://www.idosell.com/pl/mozliwosci-systemu-wms-w-sklepach-internetowych/obsluga-fulfillment/',
                                target: '_blank',
                            },
                        },
                        {
                            title: 'Bezpieczny sklep internetowy',
                            content:
                                'W IdoSell otrzymujesz najbezpieczniejszy system. Gwarantujemy Ci niezawodność i dostępność usługi przez 99.98% czasu.',
                            link: {
                                label: 'Przejdź',
                                href: 'https://www.idosell.com/pl/bezpieczenstwo/',
                                target: '_blank',
                            },
                        },
                    ]}
                />
                <CustomerSection data="string" />
                <MigrationSection
                    image={{
                        url: 'https://www.idosell.com/panel/file-gate.php?id=279153&ext=.jpeg',
                    }}
                    boxSide="left"
                    title="Chcesz przenieść swój sklep internetowy?"
                    subtitle="Migruj z dowolnej platformy OpenSource lub SaaS do IdoSell"
                    ctaButton={{
                        title: 'Przenieś sklep do IdoSell',
                        href: 'https://www.idosell.com/pl/migracja/',
                        variant: 'default',
                    }}
                >
                    <>
                        <Text mb="30px">
                            Przeniesiemy twoją bazę danych i produkty ze zdjęciami, skonfigurujemy
                            domenę, zintegrujemy płatności i kurierów. Dodatkowo zachowasz
                            wypracowaną pozycję SEO.
                        </Text>
                        <Text mb="30px">
                            Każdego miesiąca do IdoSell migruje kilkadziesiąt sklepów z innych
                            platform. Dołącz do klubu dla profesjonalistów.
                        </Text>
                    </>
                </MigrationSection>
                <ContactSection my={10} py={4} />
                <CaseStudySection
                    // my={10}
                    py={8}
                    title="Poznaj naszych sprzedawców"
                    text="Zobacz historię sklepów, które zdecydowały się na IdoSell. Dowiedz się, w jaki sposób dołączyły do grona profesjonalistów i zaczęły sprzedawać więcej."
                    casestudies={[
                        {
                            image: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=279666&ext=.jpeg',
                                alt: 'Zdjęcie wyróżniające Ministerstwo Dobrego Mydła',
                            },
                            title: 'My robimy mydło, a IdoSell załatwia całą resztę.',
                            link: {
                                label: 'Ministerstwo Dobrego Mydła',
                                href: 'https://www.idosell.com/pl/historie-klientow-idosell/ministerstwo-dobrego-mydla/',
                                target: '_blank',
                            },
                        },
                        {
                            image: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=279665&ext=.jpeg',
                                alt: 'Zdjęcie wyróżniające Flamqa',
                            },
                            title: 'Dobra świeca powinna być niczym dobre perfumy.',
                            link: {
                                label: 'Flamqa',
                                href: 'https://www.idosell.com/pl/historie-klientow-idosell/flamqa/',
                                target: '_blank',
                            },
                        },
                        {
                            image: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=287972&ext=.jpg',
                                alt: 'Zdjęcie wyróżniające zielona esencja',
                            },
                            title: 'Własna marka w e-commerce oparta o wartości i platformę IdoSell',
                            link: {
                                label: 'Zielona Esencja',
                                href: 'https://www.idosell.com/pl/historie-klientow-idosell/zielona-esencja/',
                                target: '_blank',
                            },
                        },
                    ]}
                />
                <BlogSection
                    title="Chcesz wiedzieć więcej zanim założysz swój e-sklep?"
                    blogs={[
                        {
                            image: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=279792&ext=.webp',
                                alt: 'Człowiek wpisujący dane na stronie',
                            },
                            title: 'Jak założyć sklep internetowy w 2025 roku?',
                            link: {
                                label: 'Czytaj całość',
                                href: 'https://www.idosell.com/pl/blog/jak-zalozyc-sklep-internetowy-w-2024-roku-1235327227',
                                target: '_blank',
                            },
                        },
                        {
                            image: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=279793&ext=.webp',
                                alt: 'Pani obsługująca magazyn',
                            },
                            title: 'Open Source czy SaaS - co wybrać?',
                            link: {
                                label: 'Czytaj całość',
                                href: 'https://www.idosell.com/pl/blog/open-source-czy-saas-co-wybrac-1235327234',
                                target: '_blank',
                            },
                        },
                        {
                            image: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=279794&ext=.webp',
                                alt: 'Wskazywanie wykresu na ekranie',
                            },
                            title: 'Najczęstsze błędy podczas zakładania sklepu online',
                            link: {
                                label: 'Czytaj całość',
                                href: 'https://www.idosell.com/pl/blog/najczestsze-bledy-podczas-zakladania-sklepu-online-1235327926',
                                target: '_blank',
                            },
                        },
                    ]}
                />
                <CTASection
                    title="Sprawdź możliwości IdoSell"
                    subtitle="Poznaj nasz panel, sprawdź naszą technologię, otwórz lub migruj sklep i zacznij
                    sprzedawać więcej."
                    buttons={[
                        {
                            title: 'Wypróbuj demo sklepu',
                            href: 'https://www.idosell.com/pl/demo/try-idosell-demo-for-free/',
                            variant: 'default',
                        },
                        {
                            title: 'Zamów sklep',
                            href: 'https://www.idosell.com/pl/abonamenty/',
                            variant: 'outline',
                        },
                    ]}
                />
                <CarouselSectionWithImages
                    title="Gotowe, aktualizowane przez nas integracje"
                    subTitle="Korzystaj z najważniejszych i najpopularniejszych integracji wbudowanych w twój sklep internetowy"
                    sections={[
                        {
                            label: 'Systemy płatności',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193322&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193242&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193114&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193332&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193323&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193334&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193333&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193321&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193256&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193243&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193250&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193249&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Kurierzy',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193105&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193254&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193110&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193117&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193102&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193104&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193255&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193119&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193253&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193251&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193252&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193107&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Marketplaces, porównywarki cen',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193136&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193092&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193099&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193674&ext=.png',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193145&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193147&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=246449&ext=.jpg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193134&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193150&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193240&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193134&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193148&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193122&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193149&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193091&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193135&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193675&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193093&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Operatorzy fulfillment',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193108&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193105&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193113&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193100&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193116&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Certyfikaty',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193127&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193118&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193123&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193137&ext=.svg',
                                    },
                                },
                            ],
                        },
                        {
                            label: 'Pozostali partnerzy',
                            items: [
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193112&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193106&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193109&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193096&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193103&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193125&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193101&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193676&ext=.png',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=193111&ext=.svg',
                                    },
                                },
                                {
                                    logo: {
                                        url: 'https://www.idosell.com/panel/file-gate.php?id=242359&ext=.svg',
                                    },
                                },
                            ],
                        },
                    ]}
                />
            </div>
        </ThemeProvider>
    );
}
